/** Run Theater chrome (caption-bar controls) — stage language itself lives in `beats`. */

export const theater = {
  runVisualization: 'Run visualization',
  replay: 'Replay',
  showWorkshop: 'Show workshop',
  hide: 'Hide',
  warmingUp: 'Warming up the workshop…',
  // Rendered INSIDE the R3F canvas (Html overlays) — threaded via props, not context.
  overflowMore: (n: number) => `+${n} more`,
  stageLoading: (pct: number) => `setting the stage… ${pct}%`
}
